<template>
  <section class="merchandise-info flex">
    <div class="img-container" v-if="showImage">
      <div class="mask"></div>
      <van-image class="merchandise-info__image" width="60px" height="60px" :src="goods.mainImg"></van-image>
    </div>

    <div class="flex-1 inline-flex merchandise-info__price">
      <section class="flex-1">
        <div class="name van-multi-ellipsis--l2">
          <div class="rtc-tip" v-if="showTag && goods.rxType" :style="{ 'min-width': goods.rxType ? '32px' : '0' }">
            <div class="prod-type">
              <span class="prod-type-c" v-if="goods.rxType === RxTypeNum.CHUFANGYA0">处方药</span>
              <span class="prod-type-o" v-if="goods.rxType === RxTypeNum.OTC">OTC</span>
            </div>
          </div>
          <div class="goods-name">{{ goods.itemName }}</div>
        </div>
        <div class="spec">
          {{ showSpecPrefix ? '规格：' : ''}}{{ goods.drugSpec || goods.specifications }}
        </div>
        <div class="price-1" v-if="showPrice">
          <span style="font-size: 10px">¥</span>
          <span>{{ (goods.showPrice || goods.realPrice || goods.itemPrice) | price }}</span>
        </div>
      </section>
      <section class="right">
        <div class="refund-state" @click.stop="goToRefundDetail">
          <p v-if="showGoodsRefundStatus">
            {{ goods.refundOrderNum > 1 ? '多个退款单' : goods.refundStatusDesc }}
          </p>
        </div>
        <div class="num" v-if="showItemNum">x{{ goods.itemNum }}</div>
      </section>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    goods: {
      type: Object,
      default: () => {}
    },
    showOrigPrice: {
      type: Boolean,
      default: false
    },
    showGoodsRefundStatus: {
      type: Boolean,
      default: false
    },
    showImage: {
      type: Boolean,
      default: true
    },
    showPrice: {
      type: Boolean,
      default: true
    },
    showTag: {
      type: Boolean,
      default: true
    },
    showSpecPrefix: {
      type: Boolean,
      default: false
    },
    showItemNum: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      RxTypeNum: {
        CHUFANGYA0: 1,
        OTC: 2
      }
    };
  },
  methods: {
    goToRefundDetail() {
      this.$emit('goToRefundDetail', this.goods);
    }
  }
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
.flex-1 {
  flex: 1;
}
.inline-flex {
  display: inline-flex;
}

.merchandise-info {
  padding: 16px 0px;
  position: relative;
  &::before {
    bottom: auto;
    top: 0;
  }
  .img-container {
    position: relative;
    width: 60px;
    height: 60px;
    background: rgba(0, 0, 0, 0.02);
    border-radius: 4px;
    overflow: hidden;
    margin-right: 12px;
    .mask {
      width: 60px;
      height: 60px;
      background: rgba(0, 0, 0, 0.02);
      z-index: 2;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 4px;
    }
  }
  .price {
    white-space: nowrap;
    font-size: 12px;
    line-height: 17px;
    color: #262626;
    text-align: right;
    font-weight: 500;
  }
  &__price {
    justify-content: space-between;
    .old-price {
      text-decoration: line-through;
      color: #bfbfbf;
      line-height: 14px;
      margin-top: 3px;
      // color: @rate-icon-disabled-color;
    }
    .name {
      font-size: 14px;
      color: #262626;
      display: flex;

      .goods-name {
        position: relative;
        height: 20px;
        line-height: 20px;
        left: 2px;
      }
      .rtc-tip {
        display: flex;
        align-items: center;
        overflow: hidden;
        .prod-type {
          display: inline-block;
          vertical-align: middle;
          height: 14px;
          width: 32px;
          color: #fff;
          .prod-type-o,
          .prod-type-c {
            display: inline-block;
            border-radius: 4px;
            font-size: 24px;
            background: #52c41a;
            text-align: center;
            width: 64px;
            height: 28px;
            line-height: 28px;
            font-size: 20px;
            transform: scale(0.5);
            transform-origin: 0% 0%;
          }
          .prod-type-o {
            background: #2fbb9e;
          }
        }
      }
    }
    .spec {
      color: #8c8c8c;
      margin-top: 6px;
      font-size: 12px;
    }
    .price-1 {
      margin-top: 12px;
      color: #262626;
    }
    .right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .refund-state {
        color: #ff8200;
        line-height: 20px;
        font-size: 12px;
      }
    }
    .num {
      font-size: 12px;
      color: #8c8c8c;
      text-align: right;
    }
  }
}
</style>
